import React, { useContext } from 'react';
import Context from "../context/context";
import classnames from 'classnames';
import { enableBodyScroll } from 'body-scroll-lock';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard, Scrollbar, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import { DateTime } from 'luxon';



const TopFilter = props => {
  const { activeFiltersNav, setActiveFiltersNav, setOpacity, activeFilters, setActiveFilters, filterNav, datesMenuStatus, setDatesMenuStatus, language } = useContext(Context);
  const {
    data
  } = props;

  const targetElement = document.querySelector('#lock_scroll');
  let open = false;

  let defaultFirstDate = DateTime.now().setZone("Europe/London").startOf("day");
  let defaultFilterDate = defaultFirstDate.toSeconds();
  let defaultSecondDate = defaultFilterDate + (24 * 60 * 60); // Next day


  if (activeFiltersNav["top_filter"].type === "tag") {
    defaultFilterDate = activeFiltersNav["top_filter"].options[1].value;
    console.log(defaultFilterDate, 'default')
  } else {

    if (activeFiltersNav["top_filter"].name === "weekly") {
      if (defaultFirstDate.weekday !== 1) {
        const previousMonday = defaultFirstDate.minus({ days: defaultFirstDate.weekday - 1 });
        defaultFirstDate = previousMonday.startOf("day");
      }

      defaultFilterDate = defaultFirstDate.toSeconds();
      defaultSecondDate = defaultFilterDate + (7 * 24 * 60 * 60); // Add 7 days
    }

    if (activeFiltersNav["top_filter"].name === "monthly") {
      defaultFirstDate = DateTime.now().setZone("Europe/London").startOf("month");
      defaultFilterDate = defaultFirstDate.toSeconds();

      const nextMonth = defaultFirstDate.plus({ months: 1 });
      defaultSecondDate = nextMonth.toSeconds();
    }

    if (activeFiltersNav["top_filter"].name === "yearly") {
      defaultFirstDate = DateTime.now().setZone("Europe/London").startOf("year");
      defaultFilterDate = defaultFirstDate.toSeconds();

      const nextYear = defaultFirstDate.plus({ years: 1 });
      defaultSecondDate = nextYear.toSeconds();
    }
  }





  filterNav.forEach((widget, i) => {
    if (widget.position === "top" && widget.open) {
      open = true;
    }
  })


  const options = data.options.filter((option) => {
    return option.value !== "all"
  });

  const total_options = options.length;

  const win_width = window.innerWidth;

  let dir = "vertical";
  if (win_width >= 1024) {
    dir = "horizontal";
  }

  function scrollToTop() {
    const container = document.querySelector('.filter-block'),
      pos = container.offsetTop - 52;

    if (window.innerWidth < 1024) {
      window.scrollTo({
        top: pos,
        left: 0,
        behavior: "smooth",
      });
    }
  }

  const handleClick = (value) => {
    setOpacity(false);
    const filter_nav = { ...activeFilters["top_filter"] };
    filter_nav.value = value;
    setActiveFiltersNav({
      ...activeFiltersNav,
      ["top_filter"]: filter_nav
    });

    setTimeout(() => {
      const filter = { ...activeFilters["top_filter"] };
      filter.value = value;
      setActiveFilters({
        ...activeFilters,
        ["top_filter"]: filter
      });
    }, 400);

    setDatesMenuStatus(false);

    scrollToTop();
    enableBodyScroll(targetElement);

  }

  const toggleDatesMenu = (value) => {
    setDatesMenuStatus(!datesMenuStatus);
    scrollToTop();
  }

  const closeDatesMenu = (value) => {
    setDatesMenuStatus(false);
    scrollToTop();
    enableBodyScroll(targetElement);
  }

  return (
    <>
      <div
        id="extra_filters"
        className={classnames('top-filter col-' + total_options, {
          open: open
        })}
      >
        <button type="button"
          className={classnames('top-filter-bg  ', {
            active: datesMenuStatus

          })}
          onClick={() => closeDatesMenu()}
        ></button>
        <div className="top-filter-options">
          <div className="top-filter-options-inner">
            <div
              className={classnames('top-filter-option  ', {
                active: activeFiltersNav["top_filter"].value !== data.options[0].value
              })}
            >
              <button type="button"
                className={classnames('top-filter-option-button all ', {
                  active: activeFiltersNav["top_filter"].value !== data.options[0].value
                })}
                onClick={() => handleClick(defaultFilterDate)}
              >
                {data.choose_text}
              </button>
            </div>
            <div
              className={classnames('top-filter-option  ', {
                active: activeFiltersNav["top_filter"].value === data.options[0].value
              })}
            >
              <button type="button"
                className={classnames('top-filter-option-button all ', {
                  active: activeFiltersNav["top_filter"].value === data.options[0].value
                })}
                onClick={() => handleClick(data.options[0].value)}
              >
                {data.all_text}
              </button>
            </div>

          </div>
        </div>
        <div class="top-filter-filters">
          <div
            className={classnames('top-filter-all ', {
              active: activeFiltersNav["top_filter"].value === data.options[0].value
            })}
          >
            You are viewing all {language.type}
          </div>

          <div
            className={classnames('top-filter-dates ', {
              active: activeFiltersNav["top_filter"].value !== data.options[0].value
            })}
          >
            <div className="top-filter-dates-top">
              {options.map((option, i) => {
                if (i < 2) {
                  return (
                    <button type="button"
                      className={classnames('top-filter-item ', {
                        active: activeFiltersNav["top_filter"].value === option.value && !datesMenuStatus
                      })}

                      onClick={() => handleClick(option.value)}
                    >
                      {option.name}
                    </button>
                  )
                }
              })}
              <button type="button"
                className={classnames('other-dates ', {
                  active: datesMenuStatus || (activeFiltersNav["top_filter"].value != defaultFirstDate && activeFiltersNav["top_filter"].value != defaultSecondDate)
                })}
                onClick={() => toggleDatesMenu()}
              >
                Other dates
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                  <title>Other Dates</title>
                  <path d="M2.818 2.81818H13.6362L15.1816 2.8182V16.7273H13.6362H2.818H1.27255V2.8182L2.818 2.81818Z" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M5.13623 1.27271V4.36361" stroke="white" stroke-width="1.5" stroke-linecap="square" />
                  <path d="M11.3184 1.27271V4.36361" stroke="white" stroke-width="1.5" stroke-linecap="square" />
                  <path d="M15.1816 7.45453H1.27255" stroke="white" stroke-width="1.5" stroke-linecap="square" />
                </svg>
              </button>
            </div>
            <div
              id="lock_scroll"
              className={classnames('top-filter-dates-bottom ', {
                active: datesMenuStatus
              })}
            >
              <div className="top-filter-dates-bottom-inner">
                <div className="widget-title font-title font-lead">Browse by date:</div>
                <div className="widget-label ">Please select one date</div>
                <button type="button" className="swiper-prev desktop-only">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22" fill="none">
                    <title>Prev</title>
                    <path d="M13.4343 19.4312L5.07263 10.9998L13.4343 2.56834L10.8985 2.21692e-07L-2.47876e-05 10.9998L10.8985 22L13.4343 19.4312Z" fill="white" />
                    <path d="M13.4343 19.4312L5.07263 10.9998L13.4343 2.56834L10.8985 2.21692e-07L-2.47876e-05 10.9998L10.8985 22L13.4343 19.4312Z" stroke="white" />
                  </svg>
                </button>
                <div className="swiper-outer">
                  <Swiper
                    slidesPerView={'auto'}
                    spaceBetween={0}
                    grabCursor={true}
                    direction={dir}
                    watchOverflow={true}
                    navigation={{
                      nextEl: '.swiper-next',
                      prevEl: '.swiper-prev',
                    }}
                    freeMode={true}
                    preventClicks={false}
                    modules={[Keyboard, Scrollbar, Navigation, Pagination]}
                    className="mySwiper"
                  >

                    {options.map((option, i) =>

                      <SwiperSlide
                        className={classnames('', {
                          active: activeFiltersNav["top_filter"].value == option.value
                        })}
                      >
                        <button type="button"
                          className={classnames('top-filter-item ', {
                            active: activeFiltersNav["top_filter"].value == option.value
                          })}

                          onClick={() => handleClick(option.value)}
                        >
                          {option.name}
                        </button>
                      </SwiperSlide>

                    )}
                  </Swiper>
                  <div class="swiper-filter-pagination">
                    <button type="button" className="swiper-prev">
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none">
                        <title>Prev</title>

                        <rect y="50.082" width="50" height="50" transform="rotate(-90 0 50.082)" fill="white" />
                        <path d="M13.2149 31.6329L25 19.8477L36.7851 31.6329" stroke="#E54439" stroke-width="4.58333" />
                      </svg>
                    </button>
                    <button type="button" className="swiper-next">
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none">
                        <title>Next</title>
                        <rect width="50" height="50" transform="matrix(-4.37114e-08 1 1 4.37114e-08 0 0.917969)" fill="white" />
                        <path d="M13.2149 19.3671L25 31.1523L36.7851 19.3671" stroke="#E54439" stroke-width="4.58333" />
                      </svg>
                    </button>
                  </div>

                </div>
                <button type="button" className="swiper-next desktop-only">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="22" viewBox="0 0 15 22" fill="none">
                    <title>Next</title>
                    <path d="M0.594237 19.4312L8.95593 10.9998L0.594238 2.56834L3.1301 2.21692e-07L14.0286 10.9998L3.1301 22L0.594237 19.4312Z" fill="white" />
                    <path d="M0.594237 19.4312L8.95593 10.9998L0.594238 2.56834L3.1301 2.21692e-07L14.0286 10.9998L3.1301 22L0.594237 19.4312Z" stroke="white" />
                  </svg>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TopFilter;
